///<reference path="../../../../node_modules/rxjs/add/operator/map.d.ts"/>
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalCacheManager } from '../managers/local-cache.manager';
import { NotificationPreference } from '../models/notification-preference.model';
import { UserRegistration } from '../models/user-registration/user-registration.model';
import { User } from '../models/user.model';
import { ApiUrlService } from './api-url.service';
import { ApiService } from './api.service';

@Injectable()
export class LoginAndUserApiService extends ApiService
{

    constructor(protected http: HttpClient,
                protected apiUrlService: ApiUrlService,
                protected localCacheManager: LocalCacheManager)
    {
        super(http, localCacheManager);
    }

    loginUser(email: string, password: string): Observable<User>
    {
        return this.apiRequestWithBasicAuth<User>(this.apiUrlService.loginUrl, this.HttpMethod.Get, this.getEncodedEmail(email), password)
            .pipe(
                map(response => new User(response))
            );
    }

    forgotPassword(email: string)
    {
        return this.apiRequest(this.apiUrlService.getForgotPasswordUrl(this.getEncodedEmail(email)), this.HttpMethod.Get);
    }

    sendConfirmationEmail(email: string)
    {
        return this.apiRequest(this.apiUrlService.getSendConfirmationEmailUrl(this.getEncodedEmail(email)), this.HttpMethod.Get);
    }

    registerUser(userRegistration: UserRegistration)
    {
        userRegistration.User.Email = this.getEncodedEmail(userRegistration.User.Email);
        return this.apiRequest(this.apiUrlService.registerUserUrl, this.HttpMethod.Post, JSON.stringify(userRegistration));
    }

    resetPassword(password: string, id: string, secret: string): Observable<any>
    {
        return this.apiRequest(this.apiUrlService.getResetPasswordUrl(password, id, secret), this.HttpMethod.Post);
    }

    getUserDetails(): Observable<User>
    {
        return this.apiRequest<User>(this.apiUrlService.userDetailsUrl, this.HttpMethod.Get)
            .pipe(
                map(user => new User(user))
            );
    }

    validateUser(id: string, secret: string): Observable<User>
    {
        return this.apiRequest(this.apiUrlService.getValidateUserUrl(id, secret), this.HttpMethod.Post);
    }

    validateResetLink(id: string, secret: string): Observable<User>
    {
        return this.apiRequest(this.apiUrlService.getValidateResetLinkUrl(id, secret), this.HttpMethod.Post);
    }

    updateUserInfo(user: User): Observable<any>
    {
        return this.apiRequest(this.apiUrlService.getUpdateUserInfoUrl(), this.HttpMethod.Put, { FName: user.FName, LName: user.LName, Email: user.Email });
    }

    updateUserPassword({ oldPassword, newPassword, newPasswordConfirm })
    {
        return this.apiRequest(this.apiUrlService.getUpdateUserPasswordUrl(), this.HttpMethod.Put, {
            OldPassword: oldPassword,
            NewPassword: newPassword,
            NewPasswordConfirm: newPasswordConfirm
        });
    }

    updateUserEmail({ oldEmail, newEmail, password })
    {
        return this.apiRequest(this.apiUrlService.changeUserEmail, this.HttpMethod.Post, {
            OldEmail: oldEmail,
            NewEmail: newEmail,
            Password: password
        });
    }

    resetEmail({ id, email, secret }): Observable<any>
    {
        return this.apiRequest(this.apiUrlService.getResetEmailUrl(id, this.getEncodedEmail(email), secret), this.HttpMethod.Post);
    }

    // Helper Methods
    private getEncodedEmail(email: string)
    {
        return email.replace('+', '%2b');
    }


    getNotificationPreferences(id:number):Observable<any>{
        return this.apiRequest(this.apiUrlService.getNotificationPreferencesUrl(id), this.HttpMethod.Get)
            .pipe(
                map(response => {
                    return response;
                })
            );
    }

    saveNotificationPreferences( id : number,  preferences : NotificationPreference[]):Observable<any>{
        return this.apiRequest(this.apiUrlService.setNotificationPreferencesUrl(id), this.HttpMethod.Post, preferences)
        .pipe(
            map(response => {
                return response;
            })
        );
    }

}
